export const services = [
  {
    id: 'craniosacral-therapy',
    title: 'Craniosacral Therapy',
    description: 'Gentle therapeutic technique that releases tensions deep in the body to relieve pain and dysfunction and improve whole-body health and performance.',
    price: 5000,
    duration: '60 min',
    badge: 'Popular',
    availableSlots: ['9:00 AM', '11:00 AM', '5:00 PM', '7:00 PM'],
    image: '/images/services/craniosacral.png',
    features: [
      'Deep tissue tension release',
      'Pain and dysfunction relief',
      'Improved body performance',
      'Holistic healing approach'
    ],
    longDescription: 'Craniosacral therapy is a gentle, hands-on technique that uses very light touching to balance the craniosacral system in the body. This system includes the membranes and cerebrospinal fluid that surround and protect the brain and spinal cord.'
  },
  {
    id: 'meditation',
    title: 'Guided Meditation',
    description: 'Find inner peace and mental clarity through ancient meditation techniques adapted for modern life challenges.',
    price: 600,
    duration: '25 min',
    badge: null,
    availableSlots: ['7:00 AM', '10:00 AM', '6:00 PM', '8:00 PM'],
    image: '/images/services/meditation.png',
    features: [
      'Stress reduction techniques',
      'Mindfulness practices',
      'Breathing exercises',
      'Mental clarity improvement'
    ],
    longDescription: 'Our guided meditation sessions combine traditional mindfulness practices with modern techniques to help you achieve deep relaxation, mental clarity, and emotional balance.'
  },
  {
    id: 'personal',
    title: '1:1 Personal Session',
    description: 'Personalized yoga and meditation practice tailored specifically to your individual needs, goals, and wellness journey.',
    price: 5000,
    duration: '60 min',
    badge: 'Premium',
    availableSlots: ['10:00 AM', '2:00 PM', '4:00 PM'],
    image: '/images/services/personal-session.png',
    features: [
      'Customized practice plan',
      'One-on-one guidance',
      'Progress tracking',
      'Personalized techniques'
    ],
    longDescription: 'Experience the power of personalized wellness with our 1:1 sessions. Each session is carefully designed to meet your unique needs, whether you\'re beginning your wellness journey or looking to deepen your practice.'
  }
];

export const getServiceById = (id) => {
  return services.find(service => service.id === id);
};

export const getServicesByIds = (ids) => {
  return services.filter(service => ids.includes(service.id));
};

export const getFeaturedServices = () => {
  return services.filter(service => service.badge);
};